import {
  Blocks,
  BadgeDollarSign,
  Users,
  Workflow,
  Headphones,
  ShieldCheck,
} from "lucide-react";

export const benefits = [
  {
    id: "full-cycle",
    side: "left",
    icon: Blocks,
    titleKey: "fullCycleTitle",
    descKey: "fullCycleDesc",
  },
  {
    id: "pricing",
    side: "left",
    icon: BadgeDollarSign,
    titleKey: "transparentTitle",
    descKey: "transparentDesc",
  },
  {
    id: "team",
    side: "left",
    icon: Users,
    titleKey: "experiencedTitle",
    descKey: "experiencedDesc",
  },
  {
    id: "methodology",
    side: "right",
    icon: Workflow,
    titleKey: "agileTitle",
    descKey: "agileDesc",
  },
  {
    id: "support",
    side: "right",
    icon: Headphones,
    titleKey: "supportTitle",
    descKey: "supportDesc",
  },
  {
    id: "quality",
    side: "right",
    icon: ShieldCheck,
    titleKey: "qualityTitle",
    descKey: "qualityDesc",
  },
];
